import axios from 'axios';

const apiBaseUrl = process.env.REACT_APP_API_URL || (process.env.NODE_ENV === 'production' ? '' : 'http://localhost:5000');

/** PHM Zendesk-backed endpoints can take 30–60s on a small instance; use a longer timeout than break-scheduler APIs. */
const phmApi = axios.create({
  baseURL: apiBaseUrl,
  timeout: 90000,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json'
  }
});

export default phmApi;
